import CurrencyConversion from "../../Functions/Currency";
import { facilityTypeUrls } from "../../../vuex/FacilityService/urls";
export default {
  methods: {
    removeFacility: function (facility) {
      var localFacility = JSON.parse(localStorage.getItem("facility_data"));
      localFacility.splice(localFacility.indexOf(facility), 1);
      this.$store.commit("BROWSER_FACILITIES", localFacility);
      this.$store.commit("REMOVE_FACILITY", facility);
      localStorage.setItem("facility_data", JSON.stringify(localFacility));
      if (facility.external) {
        let facilityData = this.addedExternalFacility;
        var filteredAry = facilityData.filter(function (e) {
          return e.facility_name !== facility.name;
        });
        this.$store.state.FacilityStore.new_external_facility_data = filteredAry;
      }
    },
    removeMultiArrival: function (facility) {
      var localFacility = JSON.parse(
        localStorage.getItem("camping_multi_data")
      );
      localFacility.splice(localFacility.indexOf(facility), 1);
      this.$store.commit("CAMPING_MULTI_DATA", localFacility);
      this.$store.commit("REMOVE_MULTI_ARRIVAL", facility);
      localStorage.setItem("camping_multi_data", JSON.stringify(localFacility));
    },
    removeExternalFacility: function (facility) {
      this.$store.commit("REMOVE_EXTERNAL_FACILITY", facility);
    },
    removeConfirmedExternalFacility: function (facility) {
      this.$store.commit("REMOVE_CONFIRMED_EXTERNAL_FACILITY", facility);
    },
    removeAlreadyBookedExternalFacility: function (facility) {
      this.$store.commit("REMOVE_ALREADY_BOOKED_EXTERNAL_FACILITY", facility);
    },
    removeBookedFacility: function (facility) {
      var data = {
        facility_booking_id: facility.facility_booking_public_id
      };

      this.$store.dispatch("remove_booked_accommodation", data);
      var localFacility = JSON.parse(localStorage.getItem("old_facility_data"));
      localFacility.splice(localFacility.indexOf(facility), 1);
      this.$store.commit("REMOVE_BOOKED_FACILITY", facility);
      localStorage.setItem("old_facility_data", JSON.stringify(localFacility));
    },
    removeExteranalBookedFacility: function (facility) {
      var data = {
        facility_booking_id: facility.facility_booking_public_id
      };
      this.$store.dispatch("remove_booked_accommodation", data);
      this.$store.commit("REMOVE_BOOKED_FACILITY", facility);
      localStorage.setItem("old_facility_data", JSON.stringify(localFacility));
    },
    facilityDifference: function (facility) {
      return (
        this.facilityTotal(facility) -
        this.facilityDiscount(facility) -
        this.facilityCommission(facility)
      );
    },
    facilityDiscount: function (facility) {
      if (facility.discount_status === "true") {
        var discounts = facility.discounts;
        var discount = 0;
        var facilityD = 0;
        for (var i = 0; i < discounts.length; i++) {
          if (
            this.gate_pass.tour_operator.type_public_id ===
            discounts[i].discount_type_id
          ) {
            discount = discounts[i].discount;
          }
        }
        facilityD = (this.facilityTotal(facility) * Number(discount)) / 100;
        return facilityD;
      } else {
        return 0;
      }
    },
    facilityCommission: function (facility) {
      if (facility.discount_status === "true") {
        var discounts = facility.discounts;
        var discount = 0;
        var facilityD = 0;
        for (var i = 0; i < discounts.length; i++) {
          if (
            this.gate_pass.tour_operator.type_public_id ===
            discounts[i].discount_type_id
          ) {
            discount = discounts[i].commission;
          }
        }
        facilityD = (this.facilityTotal(facility) * Number(discount)) / 100;
        return facilityD;
      } else {
        return 0;
      }
    },
    getDays: function (startDate, endDate) {
      if (startDate === endDate) {
        return 1;
      } else {
        var b = this.$moment(endDate);
        var a = this.$moment(startDate);
        return b.diff(a, "days");
      }
    },
    developPricePacks(facility) {
      var packs = [];
      facility.price.map(function (item, index) {
        if (
          item.hasOwnProperty("lower_limit_list") &&
          item.lower_limit_list.length > 0
        ) {
          // merging currency and limits
          item.lower_limit_list.map(function (pack, index) {
            var currency = { currency: item.lower_currency[index] };
            Object.assign(pack, currency);
            packs.push(pack);
          });
        }
      });
      return packs;
    },
    oldFacilityTotal: function (facility) {
      let total = 0;
      total = facility.facility_booking_total_cost;
      return total;
    },
    multiArrivalsTotal: function (facility) {
      if (facility.expected_to_pay === true) {
        let discount = Number(facility.discount) / 100;
        var days = this.getDays(facility.start_date, facility.end_date);
        var childTotal =
          Number(facility.children) * Number(facility.child_price);
        var adultTotal = Number(facility.adults * Number(facility.adult_price));
        childTotal = childTotal * days;
        adultTotal = adultTotal * days;
        var total = childTotal + adultTotal;
        total = total - discount * total;
        total = this.convert1(facility.currency, total).amount;
        if (isNaN(total) === true) {
          total = 0;
        }
        return total;
      } else {
        return 0;
      }
    },
    facilityTotal: function (facility) {
      // Converting the costs before doing the total calculations to bring it in line with
      // how calculations are done by the booking service
      var acc_total;
      var acc_children;

      var total = 0;
      var children = 0;
      var currencyIndex = 0;

      let discount = Number(facility.accommodation_discount) / 100;

      var days = this.getDays(facility.start_date, facility.end_date);
      if (
        facility.facility_type === "Accomodation" &&
        facility.accommodation_type === "Pelican"
      ) {
        var totalGuests = Number(facility.adults);
        // If it has special pricing
        // TODO: Factor in correct calculations for extra pricing
        if ("extra_price" in facility) {
          var excessPrice = 0;
          // Check if number exceeds
          if (totalGuests > facility.to_number) {
            // Excess number of people
            var excess = totalGuests - facility.to_number;
            excessPrice = Number(excess) * Number(facility.extra_price);
          }
          var limitPrice = facility.special_mandatory_price;
          total = Number(limitPrice) + Number(excessPrice);
          // Calculate with discount total - (Discount/100 * total)
          total = total * days;
          total = total - discount * total;
          total = this.convert1(facility.special_currency, total).amount;
          return total;
        } else {
          // Self Catered
          if (facility.catering_type === "9a9a77eb") {
            facility.pack_prices.lower_limit_list.map(function (price, index) {
              if (
                Number(price.lower_limit) <= Number(totalGuests) &&
                Number(price.upper_limit) >= Number(totalGuests)
              ) {
                total = Number(price.price);
                children = Number(price.child_price);
                currencyIndex = index;
              }
            });
            total = Number(
              Math.round(
                this.convert1(
                  facility.pack_prices.lower_currency[currencyIndex],
                  total
                ).amount
              )
            );
            total = total * days * Number(facility.adults);
            total =
              total +
              days *
              Number(
                Math.round(
                  this.convert1(
                    facility.pack_prices.lower_currency[currencyIndex],
                    children
                  ).amount
                )
              ) *
              Number(facility.children);
            total = total - discount * total;
          } else if (facility.catering_type === "266677c3") {
            // Fully Catered
            facility.pack_prices.upper_upper_limit_list.map(function (
              price,
              index
            ) {
              if (
                Number(price.lower_limit) <= Number(totalGuests) &&
                Number(price.upper_limit) >= Number(totalGuests)
              ) {
                total = Number(price.price);
                children = Number(price.child_price);
                currencyIndex = index;
              }
            });
            total = Number(
              Math.round(
                this.convert1(
                  facility.pack_prices.upper_currency[currencyIndex],
                  total
                ).amount
              )
            );
            total = total * days * Number(facility.adults);
            total =
              total +
              days *
              Number(
                Math.round(
                  this.convert1(
                    facility.pack_prices.upper_currency[currencyIndex],
                    children
                  ).amount
                )
              ) *
              Number(facility.children);
            total = total - discount * total;
          } else if (facility.catering_type === "377788d4") {
            facility.pack_prices.middle_middle_limit_list.map(function (
              price,
              index
            ) {
              if (
                Number(price.lower_limit) <= Number(totalGuests) &&
                Number(price.upper_limit) >= Number(totalGuests)
              ) {
                total = Number(price.price);
                children = Number(price.child_price);
                currencyIndex = index;
              }
            });
            total = Number(
              Math.round(
                this.convert1(
                  facility.pack_prices.upper_currency[currencyIndex],
                  total
                ).amount
              )
            );
            total = total * days * Number(facility.adults);
            total =
              total +
              days *
              Number(
                Math.round(
                  this.convert1(
                    facility.pack_prices.upper_currency[currencyIndex],
                    children
                  ).amount
                )
              ) *
              Number(facility.children);
            total = total - discount * total;
          }
          if (isNaN(total) === true) {
            total = 0;
          }
          return total;
        }
      } else if (facility.facility_type === "Camping Sites") {
        // var mandatoryPrice = Number(facility.mandatory_price)
        var mandatoryPrice = Number(
          Math.round(
            this.convert1(facility.currency, facility.mandatory_price).amount
          )
        );
        mandatoryPrice = Number(mandatoryPrice * Math.ceil(days / 7));
        if (facility.is_multi === true) {
          total = facility.multiTotal + mandatoryPrice;
          // total = this.convert1(facility.currency, total).amount
          if (isNaN(total) === true) {
            total = 0;
          }
          return total;
        } else {
          var childPrice = Number(
            Math.round(
              this.convert1(facility.currency, facility.child_price).amount
            )
          );
          var adultPrice = Number(
            Math.round(
              this.convert1(facility.currency, facility.adult_price).amount
            )
          );
          // var childTotal = (Number(facility.children) + Number(facility.extra_pax_children)) * Number(facility.child_price)
          // var adultTotal = (Number(facility.adults) + Number(facility.extra_pax_adults)) * Number(facility.adult_price)
          var childTotal =
            (Number(facility.children) + Number(facility.extra_pax_children)) *
            childPrice;
          var adultTotal =
            (Number(facility.adults) + Number(facility.extra_pax_adults)) *
            adultPrice;
          childTotal = childTotal * days;
          adultTotal = adultTotal * days;
          total = childTotal + adultTotal + mandatoryPrice;
          total = total - discount * total;
          // total = this.convert1(facility.currency, total).amount
          if (isNaN(total) === true) {
            total = 0;
          }
          return total;
        }
      } else if (facility.facility_type === "Accomodation") {
        if (facility.accommodation_type === "Stables") {
          if (
            facility.maximum_guests === 1 ||
            facility.name === "Pelican Catering Service" ||
            facility.public_id === "99a3e767-00bd-4de3-a5ff-478531b3b879" ||
            facility.public_id === "a6470e28-31d5-490b-8bf4-586655c8b687"
          ) {
            // Single Room
            // var mandatoryPrice1 = Number(facility.mandatory_price)

            var mandatoryPrice1 = Number(
              Math.round(
                this.convert1(facility.currency, facility.mandatory_price)
                  .amount
              )
            );
            let halfPrice = Number(mandatoryPrice1 / facility.maximum_guests);
            let extraChildren = facility.extra_pax_children;
            let extraAdults = facility.extra_pax_adults;
            var days1 = this.getDays(facility.start_date, facility.end_date);
            let extraAdultPrice = halfPrice * extraAdults * days1;
            let extraChildPrice = (halfPrice / 2) * extraChildren * days1;
            mandatoryPrice1 =
              mandatoryPrice1 *
              days1 *
              (Number(facility.adults) + Number(facility.children));
            total = mandatoryPrice1 + extraAdultPrice + extraChildPrice;
            total = total - discount * total;
            // total = this.convert1(facility.currency, total).amount
            if (isNaN(total) === true) {
              total = 0;
            }
            return total;
          } else if (facility.public_id === "9221ced6-4704-4a9c-a327-d5771f3434d8" ||
            facility.public_id === "35b57e2b-ee6c-4c84-8bb3-183f3c8b92a2") {

            // Double Room and Twin Room
            // Get the total guest count
            // let totalGuestsCount = Number(facility.adults) + Number(facility.children)

            let totalGuestsCount = Number(facility.number_of_rooms);
            let maximumAccommodationGuest = Number(facility.maximum_guests);

            let stayDuration = this.getDays(
              facility.start_date,
              facility.end_date
            );
            // let accommodationMandatoryPrice = Number(facility.mandatory_price)
            let accommodationMandatoryPrice = Number(
              Math.round(
                this.convert1(facility.currency, facility.mandatory_price)
                  .amount
              )
            );

            let adultsHalfPrice = Number(
              accommodationMandatoryPrice / facility.maximum_guests
            );
            let childrenPrice = Number(
              accommodationMandatoryPrice / facility.maximum_guests / 2
            );
            let extraChildren = facility.extra_pax_children;
            let extraAdults = facility.extra_pax_adults;
            let extraChildrenPrice = extraChildren * childrenPrice;
            let extraAdultPrice = extraAdults * adultsHalfPrice;
            let extraPrice =
              (extraAdultPrice + extraChildrenPrice) * stayDuration;
            // total = stayDuration * ((totalGuestsCount + 1) / maximumAccommodationGuest) * accommodationMandatoryPrice

            total =
              stayDuration * (totalGuestsCount * accommodationMandatoryPrice);

            total = total + extraPrice;
            total = total - discount * total;
            // total = this.convert1(facility.currency, total).amount
            if (isNaN(total) === true) {
              total = 0;
            }
            // if (totalGuestsCount % maximumAccommodationGuest > 0) {
            return total;
          } else {
            // let totalGuestsCount = Number(facility.number_of_rooms);
            let totalGuestsCount = Number(facility.adults) + Number(facility.children)
            let maximumAccommodationGuest = Number(facility.maximum_guests);

            let stayDuration = this.getDays(
              facility.start_date,
              facility.end_date
            );
            // let accommodationMandatoryPrice = Number(facility.mandatory_price)
            let accommodationMandatoryPrice = Number(
              Math.round(
                this.convert1(facility.currency, facility.mandatory_price)
                  .amount
              )
            );

            let adultsHalfPrice = Number(
              accommodationMandatoryPrice / facility.maximum_guests
            );
            let childrenPrice = Number(
              accommodationMandatoryPrice / facility.maximum_guests / 2
            );
            let extraChildren = facility.extra_pax_children;
            let extraAdults = facility.extra_pax_adults;
            let extraChildrenPrice = extraChildren * childrenPrice;
            let extraAdultPrice = extraAdults * adultsHalfPrice;
            let extraPrice =
              (extraAdultPrice + extraChildrenPrice) * stayDuration;
            // total = stayDuration * ((totalGuestsCount + 1) / maximumAccommodationGuest) * accommodationMandatoryPrice

            total =
              stayDuration * (totalGuestsCount * accommodationMandatoryPrice);

            total = total + extraPrice;
            total = total - discount * total;
            // total = this.convert1(facility.currency, total).amount
            if (isNaN(total) === true) {
              total = 0;
            }
            // if (totalGuestsCount % maximumAccommodationGuest > 0) {
            return total;

          }
        } else {
          // var _mandatoryPrice = Number(facility.mandatory_price)
          var _mandatoryPrice = Number(
            // Math.round(
            //   this.convert1(facility.currency, facility.mandatory_price).amount
            // )
            Math.round(
              this.convert1(facility.currency, facility.mandatory_price).amount
            )
          );
          var _days = this.getDays(facility.start_date, facility.end_date);
          _mandatoryPrice = _mandatoryPrice * _days;
          total = _mandatoryPrice;
          total = total - discount * total;
          // total = this.convert1(facility.currency, total).amount
          if (isNaN(total) === true) {
            total = 0;
          }
          return total;
        }
      }
    },
    totalExternalGuest: function (accommodation) {
      if (accommodation) {
        let non_priced_parameter = accommodation.non_priced_parameter;
        let counter = 0;
        if (non_priced_parameter.length > 0) {
          for (let j = 0; j < non_priced_parameter.length; j++) {
            if (
              non_priced_parameter[j].facility_parameter_name == "Adult" ||
              non_priced_parameter[j].facility_parameter_name == "Child"
            ) {
              let number = non_priced_parameter[j].parameter_default_value;
              counter = counter + parseInt(number);
            }
          }
        }

        return counter;
      }
    },
    externalFacilityTotal: function (accommodation) {
      let total = Math.round(
        this.getDays(accommodation.start_date, accommodation.end_date) *
        (accommodation.parameter_default_value *
          ((100 - accommodation.accommodation_discount) / 100) *
          this.convert1(
            accommodation.prices.currency_type,
            accommodation.prices.mandatory_price
          ).amount +
          accommodation.parameter_default_value *
          this.convert1(
            accommodation.supplement_sum.currency_type,
            accommodation.supplement_sum.amount
          ).amount)
      );

      return total;
    },
    totalOldExternalGuest: function (accommodation) {
      if (accommodation) {
        let non_priced_parameter =
          accommodation.pricing_parameter.non_priced_parameter;
        let counter = 0;
        if (non_priced_parameter.length > 0) {
          for (let j = 0; j < non_priced_parameter.length; j++) {
            if (
              non_priced_parameter[j].facility_parameter_name == "Adult" ||
              non_priced_parameter[j].facility_parameter_name == "Child"
            ) {
              let number = non_priced_parameter[j].parameter_default_value;
              counter = counter + parseInt(number);
            }
          }
        }

        return counter;
      }
    }
  },
  computed: {
    allFacilityTotal: function () {
      var total = 0;
      for (var x = 0; x < this.chosenFacilities.length; x++) {
        total = total + this.facilityTotal(this.chosenFacilities[x]);
      }
      return total;
    },
    facilitySchedule: function () {
      return this.$store.state.BookingStore.facility_schedule;
    },
    facilitySurge: function () {
      return this.$store.state.FacilityStore.surge_schedule;
    },
    chosenFacilities: function () {
      return this.$store.state.FacilityStore.chosenFacilities;
    },
    chosenExternalFacilities: function () {
      return this.$store.state.FacilityStore.chosenExternalFacility;
    },
    confirmedExternalFacilities: function () {
      return this.$store.state.FacilityStore.confirmed_external_facility_data;
    },
    postponeFacilities: function () {
      return JSON.parse(localStorage.getItem("postponed_facility_data"));
    },
    postponeExternalFacilities: function () {
      return JSON.parse(localStorage.getItem("postponed_external_facility_data"));
    },
    addedMultiArrivals: function () {
      return this.$store.state.FacilityStore.multi_camping_arrivals;
    },
    addedExternalFacility: function () {
      return this.$store.state.FacilityStore.new_external_facility_data;
    },
    bookedFacilities: function () {
      return this.$store.state.FacilityStore.bookedFacilities;
    },
    bookedExternalFacilities: function () {
      let externalBooked = this.$store.state.FacilityStore
        .bookedExternalFacilities;
      if (externalBooked.length > 0) {
        let facilityNames = externalBooked.map(external => {
          return external.facility_name;
        });

        let uniqueNames = Array.from(new Set(facilityNames));
        let bookedExternalFacilitiesArr = [];
        for (let i = 0; i < uniqueNames.length; i++) {
          let bookedExternalFacilitiesObj = {};
          bookedExternalFacilitiesObj["facility_name"] = uniqueNames[i];
          let bookedFacility = externalBooked.filter(
            external => external.facility_name === uniqueNames[i]
          );
          bookedExternalFacilitiesObj["facility_id"] =
            bookedFacility[0].facility_id;
          bookedExternalFacilitiesObj["facility_type"] =
            bookedFacility[0].facility_type;
          bookedExternalFacilitiesObj["facility_booking_check_in_date"] =
            bookedFacility[0].facility_booking_check_in_date;
          bookedExternalFacilitiesObj["facility_booking_check_out_date"] =
            bookedFacility[0].facility_booking_check_out_date;
          bookedExternalFacilitiesObj["facility_bookings"] = bookedFacility;
          bookedExternalFacilitiesArr.push(bookedExternalFacilitiesObj);
        }

        return bookedExternalFacilitiesArr;
      } else {
        return this.$store.state.FacilityStore.bookedExternalFacilities;
      }
    },
    finExternalFacilities: function () {
      return this.$store.state.FacilityStore.bookedExternalFacilities;
    },

    facilityImages: function () {
      return this.$store.state.FacilityStore.facility_images;
    },
    facilityPricing: function () {
      return this.$store.state.FacilityPricingStore.facility_pricing;
    },
    facilityUnavailabilitySchedule: function () {
      return this.$store.state.FacilityStore.facility_unavailability_schedule;
    },
    facilityContacts: function () {
      return this.$store.state.FacilityContactStore.all_facility_contacts;
    },
    facilityPricingParameter: function () {
      return this.$store.state.FacilityPricingParameterStore
        .facility_pricing_parameters;
    },
    facilityPricedParameter: function () {
      return this.$store.state.FacilityPricingParameterStore
        .priced_facility_parameter;
    },
    facilityExtraPricing: function () {
      return this.$store.state.FacilityExtraPricingStore.facility_extra_pricing;
    },
    externalFacilityCommission: function () {
      return this.$store.state.FacilityExtraPricingStore.facility_commission;


    },
    allFacilities: function () {
      return this.$store.state.FacilityStore.active_facilities;

    },
    allAvailabileFacilities: function () {
      return this.$store.state.FacilityStore.available_facilities;
    },
    allAvailableExternalFacilities: function () {
      return this.$store.state.FacilityStore.available_external_facilities;
    },
    inactiveFacilities: function () {
      return this.$store.state.FacilityStore.inactive_facilities;
    },
    vehicleSelection: function () {
      return this.$store.state.FacilityStore.browser_vehicles;
    },
    allCampsites: function () {
      return this.$store.state.FacilityStore.active_camping;
    },
    allAccommodations: function () {
      return this.$store.state.FacilityStore.active_accommodations;
    },
    allActiveAccommodationCampsite: function () {
      return this.$store.state.FacilityStore.active_accommodation_campsite;
    },
    browserFacilities: function () {
      // this.$store.commit('BROWSER_FACILITIES', JSON.parse(localStorage.getItem('facility_data')))
      return this.$store.state.FacilityStore.browser_facilities;
    },
    singleFacility: function () {
      return this.$store.state.FacilityStore.facility;
    },
    singlePricing: function () {
      return this.$store.state.PricingStore.pricing;
    },
    updateFacility: function () {
      if (this.$route.name === "EditFacility") {
        this.facility.description = this.singleFacility.description;
        this.facility.name = this.singleFacility.name;
        this.facility.code = this.singleFacility.code;
        this.facility.analysis_code = this.singleFacility.analysis_code;
        this.facility.outlet_analysis_code = this.singleFacility.outlet_analysis_code;
        this.facility.google_analytics_code = this.singleFacility.google_analytics_code;
        this.facility.catering_levy = this.singleFacility.catering_levy;
        this.facility.vat = this.singleFacility.vat;
        this.facility.has_extras = this.singleFacility.has_extras;
        this.facility.maximum_guests = this.singleFacility.maximum_guests;
        this.facility.facility_type_id = this.singleFacility.facility_type_id;
        this.facility.accomodation_type_id = this.singleFacility.accomodation_type_id;
        this.facility.quantity = this.singleFacility.quantity;
        this.facility.commission_account_code = this.singleFacility.commission_account_code;
        this.facility.percentage_commission = this.singleFacility.percentage_commission;
        
        if (this.singleFacility.allocation) {
          this.facility.allocation_id = this.singleFacility.allocation.public_id;
        }
      }
    },
    facilitySplitRevenueData: function () {
      return this.$store.state.FacilityContactStore.facility_revenue_split;
    },

  },
  mixins: [CurrencyConversion]
};
